import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTrackClickedToOpenImportFromDeviceModal, useTrackInitiateUpload } from "@air/analytics";
import { createContext, memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import { DropzoneOverlay } from "./DropzoneOverlay";
export const UPLOAD_INPUT = "UPLOAD_INPUT";
export const UploadContext = /*#__PURE__*/ createContext({
    openUploader: ()=>{
        console.error("UploadContext is not provided");
    }
});
export const UploadDropzone = /*#__PURE__*/ memo((param)=>{
    let { onUpload, children, disabled = false } = param;
    const { trackInitiateUpload } = useTrackInitiateUpload();
    const { trackClickedToOpenImportFromDeviceModal } = useTrackClickedToOpenImportFromDeviceModal();
    const [inputType, setInputType] = useState(null);
    const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
        onDrop: (acceptedFiles, fileRejections, event)=>{
            setInputType(null);
            onUpload({
                acceptedFiles: acceptedFiles,
                rejectedFiles: fileRejections.map((param)=>{
                    let { file } = param;
                    return file;
                }),
                event
            });
            // TODO: Consider adding analytics event for when files are selected for importing
            const eventType = (event === null || event === void 0 ? void 0 : event.type) === "drop" ? "drag-drop" : (event === null || event === void 0 ? void 0 : event.type) === "change" ? "new-button" : undefined;
            if (!!eventType) {
                trackInitiateUpload({
                    location: eventType
                });
            }
        },
        noKeyboard: true,
        onFileDialogCancel: ()=>setInputType(null),
        disabled,
        noClick: true,
        useFsAccessApi: false
    });
    const openRef = useRef(open);
    openRef.current = open;
    // Only open the uploader when the inputType changes
    useEffect(()=>{
        if (inputType) {
            openRef.current();
        }
    }, [
        inputType
    ]);
    const openUploader = useCallback((params)=>{
        // Uploading works, but on ios devices, a runtime error is shown on local build:
        // Error: NotAllowedError: The request is not allowed by the user agent or the platform in the current context
        trackClickedToOpenImportFromDeviceModal();
        var _params_type;
        setInputType((_params_type = params === null || params === void 0 ? void 0 : params.type) !== null && _params_type !== void 0 ? _params_type : "files");
    }, [
        trackClickedToOpenImportFromDeviceModal
    ]);
    const contextValue = useMemo(()=>({
            openUploader
        }), [
        openUploader
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative h-full",
        ...getRootProps(),
        children: [
            inputType === "folders" ? /*#__PURE__*/ _jsx("input", {
                "data-testid": UPLOAD_INPUT,
                ...getInputProps(),
                // @ts-ignore - https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory - "directory" is a nonstandard prop but is the only way to do it 💁
                webkitdirectory: "",
                mozdirectory: "",
                directory: "",
                type: "file"
            }) : /*#__PURE__*/ _jsx("input", {
                "data-testid": UPLOAD_INPUT,
                ...getInputProps()
            }),
            isDragActive && /*#__PURE__*/ _jsx(DropzoneOverlay, {}),
            /*#__PURE__*/ _jsx(UploadContext.Provider, {
                value: contextValue,
                children: children
            })
        ]
    });
});
UploadDropzone.displayName = "UploadDropzone";
